
import appEs from './es.js'; 
import appPt from './pt.js'; 
export default {
    es:{
        ...appEs
    },
    pt: {
        ...appPt
    }
}